import {
  arrayBufferDownload,
  arrayBufferDownloadExcel,
  downloadCSV,
} from "../../../../utils/download";
import {
  decorateEmptyGridValues,
  setColumnDefaultExtraProps,
} from "../../../../utils/table/gridUtils";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_VEHICLE_MODEL_LIST,
  TOAST,
  FETCH_VEHICLE_MODEL_INIT,
  FETCH_VEHICLE_MODEL_DETAIL,
  EXPORT_VEHICLE_MODEL,
  CREATE_VEHICLE_MODEL,
  EDIT_VEHICLE_MODEL,
  INIT_CREATE_VEHICLE_MODEL_SCREEN,
  VEHICLE_MODELDD,
  DELETE_VEHICLE_MODEL,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  VEHICLE_MODEL_SAVE_TABLE_STATE,
} from "../../../types/vehiclemodel.type";

const formFieldValueMap = {
  id: null,
  modBy: "",
  modTime: "",
  status: 1,
  title: "",
  userId: "",
};

const INITIAL_STATE = {
  vehicleModelListview: [],
  vehicleModelDD: [],
  isVehicleModelDDSuccess: false,
  isVehicleModelDDError: false,
  isLoading: false,
  error: null,
  formFieldValueMap,
  isVehicleModelCreateSuccess: false,
  isVehicleModelCreateError: false,
  isVehicleModelDetailSuccess: false,
  isVehicleModelDetailError: false,
  isVehicleModelEditSuccess: false,
  isVehicleModelEditError: false,
  isVehicleModelExportSuccess: false,
  isVehicleModelExportError: false,
  isUploadImageSuccess: false,
  isUploadImageError: false,
  imageUploadResponse: null,
  savedTableState: null,
};

const tranformToGridView = (data) => {
  const rows = data.map((item) => {
    const { crtBy, crtTime, id, makeTitle, modBy, modTime, status, title } =
      item;

    const transformedValues = {
      crtBy,
      crtTime,
      id,
      makeTitle,
      modBy,
      modTime,
      status,
      title,
    };
    const decoratedValues = {};
    Object.keys(transformedValues).forEach((key) => {
      decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
    });
    return decoratedValues;
  });

  const columns = [
    {
      colLabel: "ID",
      dataKey: "id",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Model",
      dataKey: "title",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Make",
      dataKey: "makeTitle",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Crt By",
      dataKey: "crtBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Crt Time",
      dataKey: "crtTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Mod By",
      dataKey: "modBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Edit Time",
      dataKey: "modTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Status",
      dataKey: "status",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
  ];

  return {
    datas: { columns, rows },
  };
};

export const vehicleModelReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_VEHICLE_MODEL_INIT:
      return { ...INITIAL_STATE, isLoadingPage: true, savedTableState: state.savedTableState };
    case FETCH_VEHICLE_MODEL_DETAIL.START:
      return { ...state, isLoading: true, isVehicleModelDetailSuccess: false };
    case EXPORT_VEHICLE_MODEL.START:
    case UPLOAD_IMAGE.START:
    case FETCH_VEHICLE_MODEL_LIST.START:
    case CREATE_VEHICLE_MODEL.START:
    case EDIT_VEHICLE_MODEL.START:
    case VEHICLE_MODELDD.START:
    case DELETE_VEHICLE_MODEL.START:
      return { ...state, isLoading: true };

    case FETCH_VEHICLE_MODEL_LIST.SUCCESS: {
      const { page, data } = action.payload;

      let resetState = {
        vehicleModelListview: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isVehicleModelCreateSuccess: false,
        isVehicleModelCreateError: false,
        savedTableState: state.savedTableState,
      };
      if (!data) {
        return resetState;
      }
      const { number, size, totalElements, totalPages } = page;
      const { datas } = tranformToGridView(data);
      return {
        ...resetState,
        vehicleModelListview: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
      };
    }
    case FETCH_VEHICLE_MODEL_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        vehicleModelListview: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
        isvehicleModelDeletionSuccess: false,
        isvehicleModelDeletionError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }

    case FETCH_VEHICLE_MODEL_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
            temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isVehicleModelDetailSuccess: true,
      };
    }
    case FETCH_VEHICLE_MODEL_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isVehicleModelDetailSuccess: false,
        isVehicleModelDetailError: true,
      };
    }

    //DD
    case VEHICLE_MODELDD.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        vehicleModelDD: temp,
        isVehicleModelDDSuccess: true,
        isVehicleModelDDError: false,
      };
    }
    case VEHICLE_MODELDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isVehicleModelDDSuccess: false,
        isVehicleModelDDError: true,
      };
    }
    //END DD

    // UPLOAD_IMAGE Start
    case UPLOAD_IMAGE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isUploadImageSuccess: false,
        isUploadImageError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case UPLOAD_IMAGE.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        imageUploadResponse: data,
        isUploadImageSuccess: true,
        isUploadImageError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // UPLOAD_IMAGE End

    // Export Start
    case EXPORT_VEHICLE_MODEL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isVehicleModelExportSuccess: false,
        isVehicleModelExportError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case EXPORT_VEHICLE_MODEL.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "vehicle-make.xls");
      return {
        ...state,
        isVehicleModelExportSuccess: true,
        isVehicleModelExportError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // Export End

    // EDIT
    case EDIT_VEHICLE_MODEL.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isVehicleModelEditSuccess: false,
        isVehicleModelEditError: true,
      };
    }

    case EDIT_VEHICLE_MODEL.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isVehicleModelEditSuccess: true,
        isVehicleModelEditError: false,
      };
    }

    // EDIT END

    // Create
    case INIT_CREATE_VEHICLE_MODEL_SCREEN: {
      return { ...INITIAL_STATE, savedTableState: state.savedTableState };
    }

    case CREATE_VEHICLE_MODEL.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isVehicleModelCreateSuccess: false,
        isVehicleModelCreateError: true,
      };
    }
    case CREATE_VEHICLE_MODEL.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isVehicleModelCreateSuccess: true,
        isVehicleModelCreateError: false,
      };
    }

    //End

    case DELETE_VEHICLE_MODEL.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isVehicleModelDeleteSuccess: true,
        isVehicleModelDeleteError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    case DELETE_VEHICLE_MODEL.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isVehicleModelDeleteSuccess: false,
        isVehicleModelDeleteError: true,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY:
      return {
        ...state,
        shouldOpenDeleteConfirmationPopup: action.payload,
        isVehicleModelDeleteSuccess: false,
        isVehicleModelDeleteError: false,
      };

    case VEHICLE_MODEL_SAVE_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }

    case TOAST.RESET: {
      return {
        ...state,
        isVehicleModelCreateSuccess: false,
        isVehicleModelCreateError: false,
        isVehicleModelEditError: false,
        isVehicleModelEditSuccess: false,
        isVehicleModelDetailError: false,
      };
    }
    default:
      return state;
  }
};
